import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AltAccessibilityModule} from '@nh/angular-tses';
import {TemplatiserModule} from '../templatiser/templatiser.module';
import {UserDisplayModule} from '../user-display/user-display.module';
import {DepartureIndexComponent} from './departure-index.component';

@NgModule({
  imports: [DepartureIndexModule.IMPORTS, AltAccessibilityModule],
  declarations: DepartureIndexModule.DECLARATIONS,
  exports: DepartureIndexModule.DECLARATIONS
})
export class DepartureIndexModule {
  public static IMPORTS = [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    UserDisplayModule,
    TemplatiserModule,
    MatPaginatorModule
  ];

  public static DECLARATIONS = [DepartureIndexComponent];
}
